import { navigate } from '@reach/router';
import { SEARCH_PANEL_GET_QUOTE_SEARCH_SELECTION_BEHAVIOR } from '../../components/searchPanel/graphql/__generated__/SEARCH_PANEL_GET_QUOTE_SEARCH_SELECTION_BEHAVIOR';

type BehaviorPayload = {
  type?: string | null;
  location?: string | null;
};

type InputData = {
  hasMigratedPolicy?: BehaviorPayload | null;
  quoteSearchSelectionBehavior?: BehaviorPayload | null;
};

export default (data: InputData | undefined) => {
  const behavior = data?.quoteSearchSelectionBehavior ?? data?.hasMigratedPolicy;

  if (!behavior?.location || !behavior?.type) {
    console.error('Could not determine quote behavior');
    return null;
  }

  const { type, location } = behavior;

  switch (type) {
    case 'navigate':
      navigate(location!);
      break;
    case 'redirect':
      window.open(location!, '_self');
      break;
    default:
      break;
  }

  return null;
};
